import { render, staticRenderFns } from "./RotaManage.vue?vue&type=template&id=2b3a9536&scoped=true"
import script from "./RotaManage.vue?vue&type=script&lang=js"
export * from "./RotaManage.vue?vue&type=script&lang=js"
import style0 from "./RotaManage.vue?vue&type=style&index=0&id=2b3a9536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a9536",
  null
  
)

export default component.exports